"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var directive_1 = require("./directive");
var forms_1 = require("@angular/forms");
var JWBootstrapSwitchModule = /** @class */ (function () {
    function JWBootstrapSwitchModule() {
    }
    JWBootstrapSwitchModule.decorators = [
        { type: core_1.NgModule, args: [{
                    imports: [
                        forms_1.FormsModule
                    ],
                    declarations: [directive_1.JWBootstrapSwitchDirective],
                    exports: [
                        directive_1.JWBootstrapSwitchDirective,
                        forms_1.FormsModule
                    ]
                },] },
    ];
    /** @nocollapse */
    JWBootstrapSwitchModule.ctorParameters = function () { return []; };
    return JWBootstrapSwitchModule;
}());
exports.JWBootstrapSwitchModule = JWBootstrapSwitchModule;
//# sourceMappingURL=index.js.map